module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"yourAccountLabel":"Your account","contactSummary":"{contactTotal} of {contactLimit} contacts used"}}')
  delete Component.options._Ctor
}
